import {
  ApplicationConfig,
  inject,
  isDevMode,
  provideAppInitializer,
  provideBrowserGlobalErrorListeners
} from '@angular/core';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { provideRouter } from '@angular/router';
import { OAuthService, OAuthStorage, provideOAuthClient } from 'angular-oauth2-oidc';
import { ConfirmationService, MessageService } from 'primeng/api';
import { DialogService } from 'primeng/dynamicdialog';
import { providePrimeNG } from 'primeng/config';
import { routes } from './app.routes';
import { authCodeFlowConfig } from '@v1/core/oauth/auth.config';
import { SessionMonitorService } from '@v1/core/oauth/session-monitor.service';
import { authErrorInterceptor } from '@v1/app/interceptors/auth-error.interceptor';
import { tokenInterceptor } from '@v1/app/interceptors/token.interceptor';
import { ConfigurationRepository } from '@v1/modules/configuration/dom/ports/configuration.repository';
import {
  ConfigurationHttpRepository
} from '@v1/modules/configuration/iface/output-adapters/configuration-http.repository';
import { primeUiLicense } from '@env/environment.license.local';
import { provideServiceWorker } from '@angular/service-worker';
import { ConfigurationTheme } from '@v1/core/theme/configuration-theme';
import { AppStoreRepository } from '@v1/modules/app-store/dom/ports/app-store.repository';
import { AppStoreHttpRepository } from '@v1/modules/app-store/iface/output-adapters/app-store-http.repository';

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideRouter(routes),
    provideHttpClient(withInterceptors([authErrorInterceptor, tokenInterceptor])),
    provideOAuthClient(),
    { provide: OAuthStorage, useValue: localStorage },
    provideAppInitializer(() => {
      const oauthService = inject(OAuthService);
      oauthService.configure(authCodeFlowConfig);
      oauthService.setupAutomaticSilentRefresh();
      inject(SessionMonitorService).start();
    }),
    providePrimeNG({ ...ConfigurationTheme(), license: primeUiLicense }),
    MessageService,
    ConfirmationService,
    DialogService,
    provideServiceWorker('ngsw-worker.js', {
      enabled: !isDevMode(),
      registrationStrategy: 'registerWhenStable:30000',
    }),
    {provide: ConfigurationRepository, useClass: ConfigurationHttpRepository},
    { provide: AppStoreRepository, useClass: AppStoreHttpRepository },
  ]
};
